<ion-tabs>

    <ion-tab-bar slot="bottom" id="app-tab-bar">
        <ion-tab-button tab="live-score">
            <ion-icon name="radio-outline"></ion-icon>
            <ion-label>{{ 'In progress' | translate }}</ion-label>
            <ion-badge *ngIf="liveScoreBadge > 0">{{liveScoreBadge}}</ion-badge>
        </ion-tab-button>

        <ion-tab-button tab="upcoming">
            <ion-icon name="calendar-outline"></ion-icon>
            <ion-label> {{ 'Schedule' | translate }}</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="completed">
            <ion-icon name="checkmark-done-circle-outline"></ion-icon>
            <ion-label> {{ 'Results' | translate }}</ion-label>
            <ion-badge *ngIf="completedBadge > 0">{{completedBadge}}</ion-badge>
        </ion-tab-button>

        <ion-tab-button *ngIf="isShow" tab="draw">
            <ion-icon name="trophy-outline"></ion-icon>
            <ion-label> {{ 'Draw' | translate }}</ion-label>
        </ion-tab-button>

        @if (canViewPlayerTab()) {
            <ion-tab-button tab="players">
                <ion-icon name="people"></ion-icon>
                <ion-label> {{ 'Players' | translate }}</ion-label>
            </ion-tab-button>
        }
        @if (canViewStandingsTab()) {
            <ion-tab-button tab="standings">
                <ion-icon name="list"></ion-icon>
                <ion-label> {{ 'Standings' | translate }}</ion-label>
            </ion-tab-button>
        }
    </ion-tab-bar>
</ion-tabs>